"use client";
import { useState as s, useEffect as C } from "react";
const j = ({
  primaryRef: l,
  secondaryRef: i,
  orientation: S = "horizontal",
  scrollRef: t,
  scrollOffset: r
}) => {
  const [z, g] = s(0), [H, b] = s(0), [W, v] = s(0), [L, T] = s(0), [d, P] = s(0), [k, x] = s(0);
  C(() => {
    t.current && (g(t.current.scrollWidth), b(t.current.clientWidth), v(t.current.scrollLeft), T(t.current.scrollHeight), P(t.current.clientHeight), x(t.current.scrollTop));
  }, [t]);
  const h = (n) => ({
    scrollSize: n === "vertical" ? L : z,
    clientSize: n === "vertical" ? d : H,
    scrollPosition: n === "vertical" ? k : W
  }), o = (n) => {
    if (l != null && l.current && (i != null && i.current) && (t != null && t.current)) {
      const { clientSize: u, scrollSize: e } = h(S);
      n <= r ? l.current.disabled = !0 : l.current.disabled = !1;
      const c = e - u - r;
      n >= c && (i != null && i.current) ? i.current.disabled = !0 : i.current.disabled = !1;
    }
  };
  return {
    onResize: () => {
      if (l != null && l.current && (i != null && i.current) && (t != null && t.current)) {
        const { clientSize: n, scrollSize: u, scrollPosition: e } = h(S);
        n < u ? (l.current.style.display = "block", i.current.style.display = "block") : (l.current.style.display = "none", i.current.style.display = "none"), o(e);
      }
    },
    scrollHandler: (n) => {
      if (t != null && t.current) {
        const { clientSize: u, scrollPosition: e } = h(S);
        let c = 0;
        n ? c = e - u / 2 : c = e + u / 2, S === "vertical" ? t.current.scrollTop = c : t.current.scrollLeft = c, o(c);
      }
    }
  };
};
export {
  j as default,
  j as useScroll
};
